/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Confirm_Revokes_Share_LinkInputs */



/**
* | output |
* | --- |
* | "Its public share link is switched off now and stays off after a restore." |
*
* @param {Chat_Tool_Confirm_Revokes_Share_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_revokes_share_link = /** @type {((inputs?: Chat_Tool_Confirm_Revokes_Share_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Revokes_Share_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der öffentliche Freigabelink wird sofort abgeschaltet und bleibt auch nach dem Wiederherstellen aus.")
	return /** @type {LocalizedString} */ ("Its public share link is switched off now and stays off after a restore.")
});